/* eslint-disable @typescript-eslint/no-require-imports, @typescript-eslint/no-unsafe-assignment */
import type { ImgHTMLAttributes } from 'react'

const navWebpImageContext = require.context('@resources/img/all-products/nav', false, /\.webp$/)
const navJpgImageContext = require.context('@resources/img/all-products/nav', false, /\.jpg$/)
const navWebpImageKeys = new Set(navWebpImageContext.keys())
const navJpgImageKeys = new Set(navJpgImageContext.keys())

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'srcSet'> & {
  slug: string
}

export const hasProductNavImageSet = (slug: string) => {
  return navWebpImageKeys.has('./' + slug + '.webp')
    && navWebpImageKeys.has('./' + slug + '@2x.webp')
    && navJpgImageKeys.has('./' + slug + '.jpg')
    && navJpgImageKeys.has('./' + slug + '@2x.jpg')
}

const getProductNavImage = (imageContext: __WebpackModuleApi.RequireContext, fileName: string) => {
  return imageContext('./' + fileName) as string
}

export default function ProductNavPicture(props: Props) {
  const { slug, width = 100, height = 100, ...imgProps } = props

  if (!hasProductNavImageSet(slug)) {
    return null
  }

  const webp1x = getProductNavImage(navWebpImageContext, slug + '.webp')
  const webp2x = getProductNavImage(navWebpImageContext, slug + '@2x.webp')
  const jpg1x = getProductNavImage(navJpgImageContext, slug + '.jpg')
  const jpg2x = getProductNavImage(navJpgImageContext, slug + '@2x.jpg')

  return <picture>
    <source type="image/webp" srcSet={webp1x + ' 1x, ' + webp2x + ' 2x'} />
    <source type="image/jpeg" srcSet={jpg1x + ' 1x, ' + jpg2x + ' 2x'} />
    <img
      src={jpg1x}
      srcSet={jpg1x + ' 1x, ' + jpg2x + ' 2x'}
      width={width}
      height={height}
      {...imgProps}
    />
  </picture>
}
